import React, { useEffect, useState } from 'react';
import { Icon } from '@b-design/fusion';
import Requests from '@/services/request';
import { formatTime } from '@/utils/index';
import { getQueryStringArgs } from '@/utils/url-parse';
import { Message } from '@b-design/fusion';
import { Table, Modal, Form, Input, Popover } from 'antd';
import Button, { FormSubmit } from '@/components/Button';
import CalculateComponent from '@/components/CalculateComponent';
import PaginationComponent from '@/components/PaginationComponent';
import './index.less';
import $i18n from '../../../../../i18n';

const StatusList = {
  AUTHED: {
    title: $i18n.get({ id: 'aopf.component.MiniappsRedirectURL.Approved', dm: '审批通过' }),
    color: '#00C76D',
    bgColor: 'rgba(235,255,246,0.7)',
  },
  IN_REVIEW: {
    title: $i18n.get({ id: 'aopf.component.MiniappsRedirectURL.UnderApproval', dm: '审批中' }),
    color: '#FF7E33',
    bgColor: 'rgba(255,244,237,0.7)',
  },
  REFUSED: {
    title: $i18n.get({ id: 'aopf.component.MiniappsRedirectURL.Rejected', dm: '已拒绝' }),
    color: 'rgb(253, 67, 64)',
    bgColor: 'rgb(255, 242, 242)',
  },
  WITHDRAWN: {
    title: $i18n.get({ id: 'aopf.component.MiniappsRedirectURL.Withdrawn', dm: '已撤回' }),
    color: '#585F7E',
    bgColor: 'rgba(242,243,247,0.7)',
  },
};
const MiniappsRedirectURL = ({
  currentTabKey,
  openApply,
  setOpenApply,
}: {
  currentTabKey: string;
  openApply: boolean;
  setOpenApply: (value: boolean) => void;
}) => {
  const [form] = Form.useForm();
  const { spaceId, appId } = getQueryStringArgs();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState<any>([]);
  const [pageConfig, setPageConfig] = useState({
    pageSize: 10,
    current: 1,
    total: 0,
  });
  const [contentHeight, setContentHeight] = useState(200);

  const queryList = () => {
    Requests.get('/rest/intercnn/app/queryUrlWhiteList', {
      spaceId,
      appId,
      currentPage: pageConfig.current,
      pageSize: pageConfig.pageSize,
    }).then((data) => {
      setDataSource(data?.list || []);
      setPageConfig({
        ...pageConfig,
        total: data?.total || 0,
      });
    });
  };

  const querySave = async () => {
    const values = await form.validateFields();
    try {
      await Requests.post('/rest/intercnn/app/configUrlWhiteList', {
          spaceId,
          appId,
          ...values,
          urls: values.urls
            ?.split('\n')
            ?.filter((v) => v)
            ?.join(','),
        }); 
      Message.success(
        $i18n.get({
          id: 'aopf.component.MiniappsRedirectURL.TheApplicationHasBeenSubmitted',
          dm: '申请已提交，请等待',
        }),
      );
      setLoading(false);
      queryList();
      setVisible(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    queryList();
  }, [pageConfig.pageSize, pageConfig.current]);

  useEffect(() => {
    if (openApply && currentTabKey === 'MiniappsRedirectURL') {
      setVisible(true);
      setTimeout(() => {
        form?.resetFields();
      }, 100);
      setOpenApply(false);
    }
  }, [openApply, currentTabKey]);

  const columnsList = [
    {
      dataIndex: 'urlName',
      title: $i18n.get({ id: 'aopf.component.MiniappsRedirectURL.UrlName', dm: 'URL 名称' }),
      render: (v) => (
        <Popover
          content={<div style={{ maxWidth: '400px', wordBreak: 'break-all' }}>{v}</div>}
          placement="topLeft"
        >
          <div className="ellipsis-td">{v}</div>
        </Popover>
      ),
    },
    {
      dataIndex: 'urls',
      title: $i18n.get({ id: 'aopf.component.MiniappsRedirectURL.UrlAddress', dm: 'URL 地址' }),
      render: (v) => {
        const arr = v?.split(',') || [];
        const children = (
          <div className="url-td" style={{ maxWidth: '400px', wordBreak: 'break-all' }}>
            {arr.map((vv) => (
              <div className="url-td-item">{vv}</div>
            ))}
          </div>
        );

        if (arr?.length > 2) {
          const _arr = arr.slice(0, 2);
          return (
            <Popover content={children} placement="topLeft">
              <div className="url-td">
                {_arr.map((vv, ii) => (
                  <div className="url-td-item">
                    {vv}{' '}
                    {ii === 1 &&
                      $i18n.get({ id: 'aopf.component.MiniappsRedirectURL.Etc', dm: '等...' })}
                  </div>
                ))}
              </div>
            </Popover>
          );
        }
        return children;
      },
    },
    {
      dataIndex: 'description',
      title: $i18n.get({ id: 'aopf.component.MiniappsRedirectURL.Description', dm: '描述' }),
      render: (v) => (
        <Popover
          content={<div style={{ maxWidth: '400px', wordBreak: 'break-all' }}>{v}</div>}
          placement="topLeft"
        >
          <div className="ellipsis-td">{v}</div>
        </Popover>
      ),
    },
    {
      dataIndex: 'approveStatus',
      title: $i18n.get({ id: 'aopf.component.MiniappsRedirectURL.Status', dm: '状态' }),
      width: 140,
      render: (v) => {
        const { title, color, bgColor } = StatusList[v] || {};
        if (!title) return '';
        return (
          <div className="approve-status-td" style={{ backgroundColor: bgColor, color: color }}>
            <span className="dot" style={{ backgroundColor: color }} />
            {title}
          </div>
        );
      },
    },
    {
      dataIndex: 'approveTime',
      title: $i18n.get({
        id: 'aopf.component.MiniappsRedirectURL.AuthorizationTime',
        dm: '授权时间',
      }),
      width: 170,
      render: (v) => formatTime(v) || '-',
    },
  ];

  return (
    <div className="global-filter-list miniapps-redirect-url-page">
      <div className="list-content">
        <Button
          type="primary"
          loading={loading}
          className="apply-btn"
          onClick={() => {
            setVisible(true);
            setTimeout(() => {
              form?.resetFields();
            }, 100);
          }}
        >
          <Icon type="add--circle--filled" size="xs" />
          {$i18n.get({ id: 'aopf.component.MiniappsRedirectURL.Application', dm: '申请' })}
        </Button>
        <Table
          loading={loading}
          dataSource={dataSource}
          columns={columnsList}
          scroll={{ y: contentHeight }}
          locale={{
            emptyText: $i18n.get({
              id: 'aopf.component.MiniappsRedirectURL.NoDataAvailable',
              dm: '暂无数据',
            }),
          }}
          className="miniapps-redirect-url-page-table"
          pagination={false}
        />

        <PaginationComponent
          total={pageConfig.total}
          current={pageConfig.current}
          pageSize={pageConfig.pageSize}
          onPageChange={(page, pageSize) => {
            setPageConfig({
              ...pageConfig,
              current: page,
              pageSize,
            });
          }}
        />
      </div>

      <CalculateComponent
        otherWidth={280}
        otherHeight={108 + 80 + 140 + 36}
        // otherHeight={88 + 48 + 50 + 56 + 56}
        windowChange={(_width, height) => {
          setContentHeight(height);
        }}
      />

      <Modal
        width={640}
        closable={false}
        open={visible}
        confirmLoading={true}
        title={$i18n.get({
          id: 'aopf.component.MiniappsRedirectURL.ApplyForAnAppletJump',
          dm: '申请小程序跳转 URL',
        })}
        onCancel={() => setVisible(false)}
        onOk={querySave}
        footer={
          <div>
            <Button onClick={() => setVisible(false)}>
              {$i18n.get({
                id: 'aopf.pages.approvals.version.info.confirm.Cancel',
                dm: '取消',
              })}
            </Button>
            <Button type="primary" onClick={querySave} style={{ marginLeft: '8px' }}>
              {$i18n.get({
                id: 'aopf.pages.approvals.version.info.confirm.Ok',
                dm: '确定',
              })}
            </Button>
          </div>
        }
        wrapClassName="custom-superapp-antd-modal-wrap miniapps-redirect-url-page-modal"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="urlName"
            label={$i18n.get({ id: 'aopf.component.MiniappsRedirectURL.UrlName.1', dm: 'URL名称' })}
            rules={[
              {
                required: true,
                message: $i18n.get({
                  id: 'aopf.component.MiniappsRedirectURL.PleaseEnter',
                  dm: '请输入URL名称',
                }),
              },
              {
                max: 100,
                min: 2,
                message: $i18n.get({
                  id: 'aopf.component.MiniappsRedirectURL.PleaseEnterCharacters',
                  dm: '请输入2-100个字符',
                }),
              },
            ]}
          >
            <Input
              placeholder={$i18n.get({
                id: 'aopf.component.MiniappsRedirectURL.PleaseEnterANameWith',
                dm: '请输入名称，至少2个字符，不超过100个字符',
              })}
            />
          </Form.Item>
          <Form.Item
            name="urls"
            label={
              <div className="urls-example">
                <span>
                  {$i18n.get({
                    id: 'aopf.component.MiniappsRedirectURL.UrlAddress.1',
                    dm: 'URL地址',
                  })}
                </span>
                <Popover
                  content={
                    <div style={{ fontSize: '12px', lineHeight: '16px', color: '#474A52' }}>
                      {$i18n.get({
                        id: 'aopf.component.MiniappsRedirectURL.HttpsWwwExampleComAllow',
                        dm: 'https://www.example.com/* —— 允许该域名下所有链接',
                      })}

                      <br />
                      {$i18n.get({
                        id: 'aopf.component.MiniappsRedirectURL.HttpsWwwExampleComData',
                        dm: 'https://www.example.com/data/* —— 允许访问data路径下的地址',
                      })}

                      <br />
                      {$i18n.get({
                        id: 'aopf.component.MiniappsRedirectURL.HttpsWwwExampleComData.1',
                        dm: 'https://www.example.com/data —— 只能访问该url',
                      })}
                    </div>
                  }
                >
                  <a>
                    {$i18n.get({
                      id: 'aopf.component.MiniappsRedirectURL.ReferenceExample',
                      dm: '参考示例',
                    })}
                  </a>
                </Popover>
              </div>
            }
            rules={[
              {
                required: true,
                message: $i18n.get({
                  id: 'aopf.pages.platformInfoSettings.FillInTheUrl',
                  dm: '请输入 URL 地址',
                }),
              },
              {
                validator: (_, value) => {
                  // const urlRegex =
                  //   /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;
                  // const urlRegex = /^(https?:\/\/)([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?::\d{1,5})?(?:\/[^\s?#]*)?(?:\?[^\s#]*)?(?:#[^\s]*)?$/i;
                  const urlRegex =
                    /^(https?:\/\/)([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}(?::\d{1,5})?(?:\/(?![^?#]*:\/\/)[^\s?#]*)?(?:\?[^\s#]*)?(?:#[^\s]*)?$/i;
                  const urlList = value?.split('\n')?.filter((v) => v);
                  if (urlList?.length) {
                    for (let i = 0; i < urlList.length; i++) {
                      const domainMatch = urlList[i].match(/^https?:\/\/([^\/]+)/);
                      if (domainMatch?.[1]?.includes('*')) {
                        return Promise.reject(
                          new Error(
                            $i18n.get({
                              id: 'aopf.component.MiniappsRedirectURL.SomeDomainNamesAreToo',
                              dm: '部分域名范围过大，请填写具体的二、三级域名',
                            }),
                          ),
                        );
                      }
                    }
                    for (let i = 0; i < urlList.length; i++) {
                      if (!urlRegex.test(urlList[i])) {
                        return Promise.reject(
                          new Error(
                            $i18n.get({
                              id: 'aopf.component.MiniappsRedirectURL.EnterAUrlInThe',
                              dm: '请输入正确的URL地址',
                            }),
                          ),
                        );
                      }
                    }
                    return Promise.resolve();
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input.TextArea
              placeholder={$i18n.get({
                id: 'aopf.component.MiniappsRedirectURL.EnterMultipleUrls',
                dm: '多个URL请换行输入',
              })}
              rows={4}
            />
          </Form.Item>
          <Form.Item
            name="description"
            label={$i18n.get({ id: 'aopf.component.MiniappsRedirectURL.Description', dm: '描述' })}
            rules={[
              {
                required: true,
                message: $i18n.get({
                  id: 'aopf.component.MiniappsRedirectURL.EnterADescription',
                  dm: '请输入描述',
                }),
              },
              {
                max: 400,
                min: 2,
                message: $i18n.get({
                  id: 'aopf.component.MiniappsRedirectURL.PleaseEnterCharacters.1',
                  dm: '请输入2-400个字符',
                }),
              },
            ]}
          >
            <Input.TextArea
              placeholder={$i18n.get({
                id: 'aopf.component.MiniappsRedirectURL.PleaseEnterADescriptionOf',
                dm: '请输入2-400个字符的描述',
              })}
              rows={4}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MiniappsRedirectURL;
